import { authReducer } from '@/features/auth/auth.reducer';
import { carouselReducer } from '@/features/carousel/carousel.reducer';
import { compilationReducer } from '@/features/compilation/compilation.reducer';
import { hintReducer } from '@/features/hint/hint.reducer';
import { homeReducer } from '@/features/home/home.reducer';
import { memeReducer } from '@/features/meme/meme.reducer';
import { modReducer } from '@/features/mod/mod.reducer';
import { userReducer } from '@/features/user/user.reducer';
import { loadingReducer } from '@ro-loading';
import { combineReducers } from 'redux';

export const rootReducer = combineReducers({
  auth: authReducer,
  home: homeReducer,
  user: userReducer,
  mod: modReducer,
  hint: hintReducer,
  meme: memeReducer,
  carousel: carouselReducer,
  compilation: compilationReducer,
  loading: loadingReducer,
});
